import script from "./SettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=beb98c6a&scoped=true&lang=css"
import "./SettingsView.vue?vue&type=style&index=1&id=beb98c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beb98c6a"]])

export default __exports__